module.exports = __webpack_public_path__ + "static/img/product_manufacture_UniSteel.665c4e0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_manufacture_UniSteel.svg
// module id = vomi
// module chunks = 0